import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from 'chart.js'

// Register Chart.js components
Chart.register(...registerables)

export default class extends Controller {
  static values = { 
    data: Array 
  }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  initializeChart() {
    const ctx = this.element.getContext('2d')
    
    // Colors from UI Style Guide
    const colors = {
      coral: '#f56565',     // coral-500
      teal: '#38b2ac',      // teal-500
      navy: '#4a5568',      // navy-700
      gray: '#e2e8f0'       // gray-200
    }

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.dataValue.map(d => d.month),
        datasets: [
          {
            label: 'Profile Views',
            data: this.dataValue.map(d => d.profile_views),
            borderColor: colors.coral,
            backgroundColor: `${colors.coral}20`,
            tension: 0.3,
            borderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: colors.coral,
            pointBorderColor: '#fff',
            pointBorderWidth: 2
          },
          {
            label: 'Inquiries',
            data: this.dataValue.map(d => d.inquiries),
            borderColor: colors.teal,
            backgroundColor: `${colors.teal}20`,
            tension: 0.3,
            borderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: colors.teal,
            pointBorderColor: '#fff',
            pointBorderWidth: 2
          },
          {
            label: 'Bookings',
            data: this.dataValue.map(d => d.bookings),
            borderColor: colors.navy,
            backgroundColor: `${colors.navy}20`,
            tension: 0.3,
            borderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: colors.navy,
            pointBorderColor: '#fff',
            pointBorderWidth: 2
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index'
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 20,
              usePointStyle: true,
              font: {
                size: 12,
                family: 'system-ui, -apple-system, sans-serif'
              }
            }
          },
          tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            titleFont: {
              size: 13
            },
            bodyFont: {
              size: 12
            },
            padding: 12,
            cornerRadius: 8,
            displayColors: true,
            usePointStyle: true
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              font: {
                size: 11
              },
              color: '#718096' // navy-600
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: colors.gray,
              drawBorder: false
            },
            ticks: {
              font: {
                size: 11
              },
              color: '#718096', // navy-600
              padding: 8
            }
          }
        }
      }
    })
  }
}